import createIcon from '../../createIcon';

/**
 * @component @name LiveTv
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgNkgxMy40MUwxNi43IDIuNzFMMTYgMkwxMiA2TDggMkw3LjI5IDIuNzFMMTAuNTkgNkgzQzEuOSA2IDEgNi44OSAxIDhWMjBDMSAyMS4xIDEuOSAyMiAzIDIySDIxQzIyLjEgMjIgMjMgMjEuMSAyMyAyMFY4QzIzIDYuODkgMjIuMSA2IDIxIDZaTTIxIDIwSDNWOEgyMVYyMFpNOSAxMFYxOEwxNiAxNEw5IDEwWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LiveTv = createIcon('LiveTv', [
  [
    'path',
    {
      d: 'M21 6H13.41L16.7 2.71L16 2L12 6L8 2L7.29 2.71L10.59 6H3C1.9 6 1 6.89 1 8V20C1 21.1 1.9 22 3 22H21C22.1 22 23 21.1 23 20V8C23 6.89 22.1 6 21 6ZM21 20H3V8H21V20ZM9 10V18L16 14L9 10Z',
      key: 'iovi78',
    },
  ],
]);

export default LiveTv;
